import { yupResolver } from "@hookform/resolvers/yup";
function createYupResolver(schema) {
    return yupResolver(schema);
}
export { createYupResolver };
